import { getPrismicDate } from "~/utils/prismic-utils";

export default {
  inject: { priorityCampaign: { default: { value: null } } },

  computed: {
    campaignTitle() {
      return this.priorityCampaign.value?.campaignTitle ?? "";
    },
    isIntroPriceCampaign() {
      return this.campaignTitle === "intro-price-campaign";
    },
    enhancedUIPrice() {
      const maxDiscount = Number(this.maxDiscount);
      switch (this.campaignTitle) {
        case "was-now":
          return this.price;
        case "member-campaign":
        case "velocity-campaign": {
          const price = this.price * 100;
          const enhancedUIRRPrice = this.enhancedUIRRPrice * 100;
          const discountedPrice =
            enhancedUIRRPrice - (enhancedUIRRPrice * maxDiscount) / 100;

          return (price > discountedPrice ? discountedPrice : price) / 100;
        }
        default: {
          const price = this.price * 100;
          const discount = (price * maxDiscount) / 100;
          return (price - discount) / 100;
        }
      }
    },
    enhancedUIRRPrice() {
      const showCompareAtPrice =
        this.showCompareAtPrice &&
        ["was-now", "member-campaign", "velocity-campaign"].includes(
          this.campaignTitle
        );

      return showCompareAtPrice ? this.compareAtPrice : this.price;
    },
    showCompareAtPrice() {
      return (
        this.hasDiscount(this.compareAtPrice, this.price) &&
        !this.isIntroPriceCampaign
      );
    },
    showRRPText() {
      return this.priorityCampaign.value?.showRRPText ?? true;
    },
    saleTagBgColor() {
      return this.priorityCampaign.value?.saleColor ?? "";
    },
    maxDiscount() {
      return this.priorityCampaign.value?.maxDiscount ?? 0;
    },
    campaignEndDate() {
      const campaignEndTime = getPrismicDate(
        this.priorityCampaign.value?.endTime
      );
      if (!campaignEndTime) {
        return "";
      }

      const campaignEndDate = `0${campaignEndTime.getDate()}`.slice(-2);
      const campaignEndMonth = `0${campaignEndTime.getMonth() + 1}`.slice(-2);
      return `${campaignEndDate}/${campaignEndMonth}/${campaignEndTime.getFullYear()}`;
    },
    pdpTileShowRRP() {
      return this.priorityCampaign.value?.pdpTitleShowRRP ?? true;
    },
  },

  methods: {
    getSaleHtml(html) {
      let rawHtml = html ? this.$prismic.asHtml(html) : "";

      const replacements = {
        ...(this.campaignEndDate && { __date__: this.campaignEndDate }),
        ...(this.maxDiscount && { __percentage__: this.maxDiscount }),
        ...(this.enhancedUIPrice && {
          __price__: this.$options.filters.formatCurrency(this.enhancedUIPrice),
        }),
        ...(this.compareAtPrice && {
          __compare_at_price__: this.$options.filters.formatCurrency(
            this.compareAtPrice
          ),
        }),
      };

      return rawHtml.replace(
        /__(?:date|percentage|price|compare_at_price)__/g,
        match => replacements[match] ?? match
      );
    },
  },
};
